export const environment = {
  production: true,
  baseURL: 'https://api-fuel.fudzos.co.zw'  
  // baseURL: 'http://38.242.196.215:9301'
};
